<template>
  <div>
    <card :title="warehouse ? warehouse.name : ''">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group has-label">
            <label>Datum</label>
            <el-date-picker
              v-model="date"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              @change="filterData"
              :clearable="false"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <product-category-select
            :init-product-categories="productCategories"
            :value="selectedProductCategories"
            @select="productCategorySelected"
            @remove="productCategoryRemoved"
            @deselectAll="selectedProductCategories = []"
          />
        </div>
        <div class="col-sm-6 text-right">
          <label>&nbsp;</label>
          <div class="form-group has-label">
            <a :href="downloadUrl" class="btn btn-fill btn-info">
              <i class="fa fa-download"></i>
              Download
            </a>
          </div>
        </div>
      </div>
      <warehouse-products-table
        :products="products"
        :sortable="sortable"
        :hideable-columns="hideableColumns"
        @sortBy="sortBy"
      />
      <l-pagination
        background
        layout="prev, pager, next"
        :per-page="10"
        :page-count="pageCount"
        :value="currentPage"
        @input="changePage"
        @changePerPage="changePerPage"
      />
    </card>
  </div>
</template>

<script>
import hasPagination from 'src/has-pagination'
import WarehouseProductsTable from './warehouse-products-table'
import ProductCategorySelect from 'src/components/product-category-select'
import { DatePicker } from 'element-ui'
import moment from 'moment'
import api from 'src/api'
import getSortableColumns from './get-sortable-columns'

export default {
  components: {
    WarehouseProductsTable,
    [DatePicker.name]: DatePicker,
    ProductCategorySelect
  },
  data () {
    return {
      api,
      warehouse: null,
      products: [],
      productCategories: [],
      selectedProductCategories: [],
      date: moment().format('YYYY-MM-DD'),
      sortable: {
        columns: [],
        sortColumn: 'products.name',
        sortOrders: {
          'products.name': 1,
          'product_categories.name': 1,
          'units.name': 1,
          'einkaufspreis': 1,
          'products.price': 1,
          'quantity_sum': 1,
          'inventur_quantity': 1,
          'warnschwelle': 1,
          'lager_soll_menge': 1,
          'next_expiry_date': 1
        }
      },
      hideableColumns: {
        showEkPrice: false,
        showLager: false,
        showLieferanten: false,
        showWarnschwelle: true,
        showSollMenge: true
      }
    }
  },
  mixins: [hasPagination],
  methods: {
    getData (query) {
      this.$http.get(`/warehouses/${this.$route.params.id}/products?${query}`).then(({ data }) => {
        this.products = data.data.map(stockRotation => ({ ...stockRotation, ...stockRotation.product }))
        this.pageCount = data.last_page
      })
    },
    showProduct (stockRotation) {
      this.$router.push(`/products/${stockRotation.product.id}`)
    },
    filterData () {
      this.currentPage = 1
      this.loading = true
      this.fetchTableData()
    },
    getCustomQueryData () {
      return {
        date: encodeURIComponent(this.date || moment().format('YYYY-MM-DD')),
        'sort-by-column': this.sortable.sortColumn,
        'sort-by-order': this.sortable.sortOrders[this.sortable.sortColumn] > 0 ? 'ASC' : 'DESC',
        'product_categories': this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(({ id }) => id)) : ''
      }
    },
    sortBy (column) {
      this.currentPage = 1
      this.loading = true
      this.sortable.sortColumn = column
      this.sortable.sortOrders[column] = this.sortable.sortOrders[column] * -1
      this.fetchTableData()
    },
    productCategorySelected (category) {
      this.selectedProductCategories.push(category)
      if (category.child_categories) {
        this.selectedProductCategories.push(...category.child_categories)
      }
      this.fetchTableData()
    },
    productCategoryRemoved (category) {
      const index = this.selectedProductCategories.findIndex(({ id }) => category.id === id)
      this.selectedProductCategories.splice(index, 1)
      this.fetchTableData()
    }
  },
  computed: {
    downloadUrl () {
      return `${api}/warehouses/${this.$route.params.id}/products/download?${this.getQuery()}`
    }
  },
  created () {
    this.$http.get(`/warehouses/${this.$route.params.id}`).then(({ data }) => { this.warehouse = data })
    this.$http.get('/parent_product_categories').then(({ data }) => {
      data.push({ name: 'Ohne Kategorie', id: '', child_categories: [] })
      this.productCategories = data
    })
    this.fetchTableData()
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.hideableColumns.showEkPrice = this.$store.getters.isNotFrontdesk
      this.hideableColumns.showLager = data.length > 1
      this.hideableColumns.showLieferanten = this.$store.getters.isNotFrontdesk
      this.sortable.columns = getSortableColumns(this.hideableColumns)
    })
  }
}
</script>
